import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function PrivateRoute({ component: Component, roles }) {
    const { isLoggedIn, loading, user } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="border-orange-500 border-b-2 rounded-full w-10 h-10 animate-spin" />
            </div>
        );
    }

    if (!isLoggedIn) {
        return (
            <Navigate
                to="/login"
                replace
                state={{ prefill: { link: location.pathname + location.search } }}
            />
        );
    }

    if (isLoggedIn && !user) {
        return (
            <Navigate
                to="/login"
                replace
                state={{ prefill: { link: location.pathname + location.search } }}
            />
        );
    }

    if (Array.isArray(roles) && roles.length > 0) {
        const roleMatch = roles
            .map(r => r.toLowerCase())
            .includes((user?.Role || '').toLowerCase());

        if (!roleMatch) {
            return <Navigate to="/unauthorized" replace />;
        }
    }

    return <Component />;
}
